import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7abde0cd")

_pushScopeId("data-v-7abde0cd")
const _hoisted_1 = { class: "winloss-content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "left-edge" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "right-edge" }, null, -1)
const _hoisted_7 = { class: "message" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["pop-alert-view-root", { desktop: !_ctx.isMobile }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _withDirectives(_createVNode("div", _hoisted_3, [
          _createVNode("span", { class: _ctx.headerColor }, _toDisplayString(_ctx.header), 3)
        ], 512), [
          [_vShow, _ctx.showAlrtHeader]
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("span", null, _toDisplayString(_ctx.message), 1)
        ])
      ])
    ])
  ], 2))
})